import React, { useMemo } from 'react';

import { Link } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

import AdultAgeImg from '@/assets/icon/Olybet/18+.svg';
import SSLSecuredImg from '@/assets/icon/Olybet/SSLSecured.svg';

import { RoutesEnum } from '@/enums/routes.enum';
import { tenantsCountriesEnum } from '@/enums/tenantsCountries.enum';

import { tKeys } from '@/i18n/resourses';

import { getIsTenantCountry } from '@/utils/tenant';

import * as S from './Footer.styles';

const COMPANY = 'UAB MECOM GRUPP';
const LITH_COMPANY = 'Kungla Investeeringu Oü';
const EST_COMPANY = 'Kungla Investeeringu Osaühing';

const POLICY_LINK = 'https://olygrillbar.lt/privacy-policy/';
const LITH_POLICY_LINK = 'https://olyboost.eu/privacy-policy/';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  const footerCompanyText = useMemo(() => {
    if (getIsTenantCountry(tenantsCountriesEnum.lithuania)) return LITH_COMPANY;
    if (getIsTenantCountry(tenantsCountriesEnum.estonia)) return EST_COMPANY;

    return COMPANY;
  }, []);

  const policyLink = useMemo(
    () =>
      getIsTenantCountry(tenantsCountriesEnum.lithuania)
        ? LITH_POLICY_LINK
        : POLICY_LINK,
    []
  );

  return (
    <S.Footer>
      <S.FooterImages>
        <img alt="" src={AdultAgeImg} style={{ marginRight: '16px' }} />
        <img alt="" src={SSLSecuredImg} />
      </S.FooterImages>
      <S.FooterText>{footerCompanyText}</S.FooterText>
      <S.FooterText style={{ marginTop: '8px' }}>
        <Link href={policyLink} target="_blank" textDecor="underline">
          {t(tKeys.privacyNotice)}
        </Link>
      </S.FooterText>
      <S.FooterText>
        <Link
          as={RouterLink}
          textDecor="underline"
          to={RoutesEnum.termsAndConditions}
        >
          {t(tKeys.termsAndConditions)}
        </Link>
      </S.FooterText>
    </S.Footer>
  );
};

export default Footer;
